import styled from "styled-components";

export const StarsContainer = styled.div`
  display: flex;
  color: rgb(229, 192, 57);

  svg {
    fill: currentColor;
  }
`;
